import styled from 'styled-components'
import { colors } from '../../styles/vars/colors.style'
import { TextBody, Label } from '../../styles/vars/textStyles.style'
import { mq } from '../../styles/vars/media-queries.style'
import { easings } from '../../styles/vars/easings.style'
import { clamp } from '../../styles/utils/conversion.style'
import { RichTextMain } from '../RichText/index.style'

export const BannerWrapper = styled.div`
  height: 100%;
`

export const BannerInner = styled.div`
  align-content: center;
  align-items: center;
  color: ${colors.light};
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  min-height: 80vh;
  position: relative;
  text-align: center;
`

export const BannerImageWrap = styled.div`
  bottom: 0;
  left: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
`

export const BannerImage = styled.div`
  background-image: url(${({ image }) => `${image}`});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  width: 100%;

  &:before {
    background: ${colors.dark};
    bottom: 0;
    content: '';
    left: 0;
    opacity: ${props => (props.inView ? 0.35 : 0)};
    opacity: 0.35;
    position: absolute;
    right: 0;
    top: 0;
    transition: opacity 2.4s ${easings.out.quart};
    z-index: 2;
  }
`

export const SmallImage = styled.div`
  display: inline-block;
  height: 15rem;
  margin-left: auto;
  margin-right: auto;
  width: 50%;

  img {
    height: 100%;
    margin-left: auto;
    margin-right: auto;
    object-fit: contain;
    width: 100%;
  }
`

export const BannerText = styled.div`
  z-index: 3;
  width: 100%;

  ${Label} {
    ${clamp('font-size', 12, 16)}
  }

  ${RichTextMain} {
    * + * {
      margin-top: 0;
    }
  }

  ${mq.desk} {
    ${TextBody} {
      margin: 0 auto;
      max-width: 83rem;
    }
  }
`
